module.exports = __webpack_public_path__ + "media/images/riders/small/LORIS_VERGIER-d38443f3fbccf5460f92e929e7cf65cf.png";